import { StylesConfig } from "react-select";

import theme from "../config/theme";

export const ReactSelectStyles: StylesConfig<any, boolean> = {
  container: (styles) => ({
    ...styles,
  }),
  control: (styles, { isDisabled }) => ({
    ...styles,
    backgroundColor: isDisabled ? "#f1f1f1" : "#ffffff",
    flexWrap: "nowrap",
  }),
  valueContainer: () => ({
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    padding: "5px 0 5px 10px",
  }),
  indicatorsContainer: (styles, { isDisabled }) => ({
    ...styles,
    opacity: isDisabled ? "0" : "1",
    div: {
      padding: "0 8px 0 0",
    },
  }),
  menuList: () => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: "5px 10px",
  }),
  option: (styles, { data }) => ({
    backgroundColor: data.color || theme.colors.primaryMagenta,
    margin: "6px 0",
    padding: "0 8px",
    borderRadius: "10px",
    fontSize: "13px",
    fontWeight: "600",
    lineHeight: "21px",
    color: "white",
    cursor: "pointer",
  }),
  multiValue: () => ({
    display: "flex",
    backgroundColor: "transparent",
    margin: "6px 0",
  }),
  multiValueLabel: (styles, { data }) => ({
    minHeight: "18px",
    backgroundColor: data.color || theme.colors.primaryMagenta,
    padding: "0 8px",
    borderRadius: "10px",
    fontSize: "13px",
    fontWeight: "600",
    lineHeight: "21px",
    color: "white",
  }),
  multiValueRemove: (styles, { data, isDisabled }) => ({
    ...styles,
    opacity: isDisabled ? "0" : "1",
    color: theme.colors.primaryNavy,
    ":hover": {
      backgroundColor: "transparent",
      color: data.color || theme.colors.primaryMagenta,
    },
  }),
  placeholder: () => ({
    fontSize: "13px",
    fontWeight: "700",
    lineHeight: "21px",
    color: theme.colors.darkGray,
  }),
  singleValue: (styles, { data }) => ({
    backgroundColor: data.color || theme.colors.primaryMagenta,
    margin: "6px 0",
    padding: "0 8px",
    borderRadius: "10px",
    fontSize: "13px",
    fontWeight: "600",
    lineHeight: "21px",
    color: "white",
    cursor: "pointer",
  }),
};
